'use client';

import { useState } from 'react';

import { CameraIcon } from '@depop/web-ui-kit/Icons/CameraIcon';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ButtonMinimal } from '@/components/ButtonMinimal';
import { VisualSearchUpsellModal } from '@/components/VisualSearchUpsellModal';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentRoute } from '@/modules/activityTracker/useCurrentRoute';
import { useCurrentUser } from '@/modules/user/useCurrentUser';
import { VisualSearchEntryType } from '@/modules/visualSearch/constants';

type Props = {
  desktopOnly?: boolean;
};

export function VisualSearchCameraButton({ desktopOnly }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations('common');
  const [, user] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({ userId: user?.id });
  const page = useCurrentRoute();

  function handleClick() {
    sendActivityTrackerEvent(
      ActivityTrackerEventType.VISUAL_SEARCH_ENTRY_ACTION,
      {
        type: VisualSearchEntryType.CAMERA_ICON,
        source: page,
        schemaVersion: '1.0',
      }
    );
    setIsOpen(true);
  }

  return (
    <>
      <ButtonMinimal
        className={styles.cameraButton}
        onClick={handleClick}
        type="button"
        aria-haspopup="dialog"
        {...(desktopOnly && { 'aria-controls': 'visual-search-upsell-modal' })}
        aria-label={t('VisualSearch.CameraButton')}
        title={t('VisualSearch.CameraButton')}
      >
        <CameraIcon size={desktopOnly ? 20 : 24} aria-hidden="true" />
      </ButtonMinimal>
      <VisualSearchUpsellModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        isSheet={!desktopOnly}
      />
    </>
  );
}
